export interface NavLink {
  label: string;
  href: string;
}

export interface NavDropdown {
  label: string;
  href: string;
  children?: NavLink[];
}

export const mainNavLinks: NavDropdown[] = [
  { label: "首頁", href: "/" },
  { label: "品牌介紹", href: "/about" },
  { label: "合作通路", href: "/stores" },
  { label: "常見問題", href: "/faq" },
  { label: "閱讀推薦", href: "/blog" },
];

export const footerColumns = [
  {
    title: "網站導覽",
    links: [
      { label: "品牌介紹", href: "/about" },
      { label: "常見問題", href: "/faq" },
      { label: "合作通路", href: "/stores" },
      { label: "閱讀推薦", href: "/blog" },
      { label: "書籍資料庫", href: "https://catalog.sonbook.net/", external: true },
    ],
  },
  {
    title: "相關資源",
    links: [
      { label: "崧博出版主站", href: "https://sonbook.net/", external: true },
      { label: "查看崧博出版與經銷品牌", href: "https://sonbook.net/", external: true },
    ],
  },
  {
    title: "購書通路",
    links: [
      { label: "合作通路", href: "/stores" },
      { label: "博客來", href: "https://www.books.com.tw/web/sys_puballb/books/?pubid=sonbook", external: true },
      { label: "誠品", href: "https://www.eslite.com/search?keyword=崧燁文化事業有限公司", external: true },
      { label: "金石堂", href: "https://www.kingstone.com.tw/bookpublish/publist/61749/", external: true },
    ],
  },
];
